import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";

export function WithdrawConsentModal({
  open,
  onOpenChange,
  withdrawLoading,
  handleWithdrawConsent
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-red-600 flex items-center gap-2">
            <AlertTriangle className="h-5 w-5" />
            Withdraw Consent
          </DialogTitle>
          <DialogDescription>This action cannot be undone</DialogDescription>
        </DialogHeader>
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-800 text-sm">
            <strong>Warning:</strong> This will permanently delete your child's account and all associated data including:
          </p>
          <ul className="text-red-700 text-sm mt-2 list-disc list-inside">
            <li>Learning progress and statistics</li>
            <li>Assessment history</li>
            <li>Chat history</li>
            <li>Subscription records</li>
          </ul>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button variant="destructive" onClick={handleWithdrawConsent} disabled={withdrawLoading}>
            {withdrawLoading ? "Processing..." : "Confirm Withdrawal"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
